module.exports = __webpack_public_path__ + "img/T1D_rc-16.97f260a9.png";